export default "__VITE_ASSET__Djj7QMBJ__"